import { render, staticRenderFns } from "./CommonBottomBtn.vue?vue&type=template&id=5941c426&scoped=true&"
import script from "./CommonBottomBtn.vue?vue&type=script&lang=js&"
export * from "./CommonBottomBtn.vue?vue&type=script&lang=js&"
import style0 from "./CommonBottomBtn.vue?vue&type=style&index=0&id=5941c426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941c426",
  null
  
)

export default component.exports